export function parseJsonFromStorage<T = unknown>(value: string | null): T | null {
  if (!value || value === '[object Object]' || !value.startsWith('{')) {
    return null;
  }

  try {
    return JSON.parse(value) as T;
  } catch {
    return null;
  }
}
